module.exports = __webpack_public_path__ + "img/camera.9affac2c.png";